<div class="card">
  <!-- Search Header -->
  <div class="card-header border-bottom">
    <div class="d-flex flex-column gap-3">
      <div>
        <h5 class="mb-1">{{ 'admin.places.title' | translate }}</h5>
        <p class="text-muted mb-0 small">{{ 'admin.places.description' | translate }}</p>
      </div>
      <div class="d-flex flex-column flex-md-row gap-3">
        <div class="flex-grow-1">
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0">
              <i class="fa-solid fa-search text-muted"></i>
            </span>
            <input type="text" class="form-control border-start-0 ps-0"
                   [(ngModel)]="searchQuery"
                   (keyup.enter)="onSearch()"
                   [placeholder]="'admin.places.searchPlaceholder' | translate">
          </div>
        </div>
        <div style="min-width: 200px;">
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0">
              <i class="fa-solid fa-location-dot text-muted"></i>
            </span>
            <input type="text" class="form-control border-start-0 ps-0"
                   [(ngModel)]="location"
                   [placeholder]="'admin.places.locationPlaceholder' | translate">
          </div>
        </div>
        <app-button variant="primary" (clicked)="onSearch()" [disabled]="searching || !searchQuery.trim()"
                    label="{{ 'admin.places.search' | translate }}"></app-button>
      </div>
    </div>
  </div>

  <!-- Results -->
  <div class="card-body p-0">
    @if (searching) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'common.searching' | translate }}</span>
        </div>
        <p class="text-muted mt-2 mb-0">{{ 'admin.places.searching' | translate }}</p>
      </div>
    } @else if (!searchPerformed) {
      <div class="text-center py-5 text-muted">
        <i class="fa-solid fa-magnifying-glass-location fa-3x mb-3 opacity-50"></i>
        <p class="mb-0">{{ 'admin.places.searchHint' | translate }}</p>
      </div>
    } @else if (results.length === 0) {
      <div class="text-center py-5 text-muted">
        <i class="fa-solid fa-store-slash fa-3x mb-3 opacity-50"></i>
        <p class="mb-0">{{ 'admin.places.noResults' | translate }}</p>
      </div>
    } @else {
      <div class="results-list">
        @for (place of results; track place.place_id) {
          <div class="place-item" [class.added]="place.added">
            <!-- Place Image -->
            <div class="place-image">
              @if (place.photo_url) {
                <img [src]="place.photo_url" alt="" class="place-img">
              } @else {
                <div class="place-img-placeholder">
                  <i class="fa-solid fa-store"></i>
                </div>
              }
            </div>

            <!-- Place Info -->
            <div class="place-info">
              <div class="place-header">
                <h6 class="place-name mb-1">{{ place.name }}</h6>
                @if (place.rating) {
                  <div class="place-rating">
                    <i class="fa-solid fa-star text-warning"></i>
                    <span>{{ place.rating }}</span>
                    <span class="text-muted">({{ place.rating_count }})</span>
                  </div>
                }
              </div>

              <div class="place-address text-muted small mb-2">
                <i class="fa-solid fa-location-dot me-1"></i>
                {{ place.formatted_address }}
              </div>

              <div class="place-details">
                @if (place.phone) {
                  <div class="detail-item">
                    <i class="fa-solid fa-phone text-muted"></i>
                    <a [href]="'tel:' + place.phone">{{ place.phone }}</a>
                  </div>
                }
                @if (place.website) {
                  <div class="detail-item">
                    <i class="fa-solid fa-globe text-muted"></i>
                    <a [href]="place.website" target="_blank" rel="noopener">{{ 'admin.places.visitWebsite' | translate }}</a>
                  </div>
                }
                @if (place.google_maps_url) {
                  <div class="detail-item">
                    <i class="fa-solid fa-map text-muted"></i>
                    <a [href]="place.google_maps_url" target="_blank" rel="noopener">{{ 'admin.places.viewOnMaps' | translate }}</a>
                  </div>
                }
              </div>

              @if (place.opening_hours) {
                <div class="place-hours mt-2">
                  <button class="btn btn-sm btn-link p-0 text-muted" type="button"
                          data-bs-toggle="collapse" [attr.data-bs-target]="'#hours-' + place.place_id">
                    <i class="fa-solid fa-clock me-1"></i>
                    {{ 'admin.places.openingHours' | translate }}
                    <i class="fa-solid fa-chevron-down ms-1 small"></i>
                  </button>
                  <div class="collapse mt-2" [id]="'hours-' + place.place_id">
                    <div class="hours-content">
                      {{ place.opening_hours }}
                    </div>
                  </div>
                </div>
              }
            </div>

            <!-- Add Button -->
            <div class="place-actions">
              @if (place.added) {
                <span class="badge bg-success-subtle text-success">
                  <i class="fa-solid fa-check me-1"></i>
                  {{ 'admin.places.added' | translate }}
                </span>
              } @else {
                <app-button
                  variant="primary"
                  size="sm"
                  [disabled]="place.adding"
                  (clicked)="addPlace(place)"
                  label="{{ place.adding ? ('common.saving' | translate) : ('admin.places.add' | translate) }}">
                </app-button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
